"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17 10.003A6.99 6.99 0 0 1 10.014 17 7 7 0 0 1 3 9.997C3 6.134 6.141 2.994 10.005 3A6.993 6.993 0 0 1 17 10.003m-1.392.008a5.606 5.606 0 0 0-5.596-5.62 5.615 5.615 0 0 0-5.62 5.598c-.006 3.088 2.505 5.615 5.583 5.62a5.606 5.606 0 0 0 5.633-5.598"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.565 9.32c-.034.07-.059.115-.08.162-.12.263-.235.529-.357.791a.685.685 0 0 1-.664.424q-1.11.002-2.22 0c-.354-.001-.63-.216-.702-.54a.69.69 0 0 1 .666-.85c.548-.006 1.096-.002 1.645-.002h.18q.043-.085.08-.167l.624-1.385a.9.9 0 0 1 .612-.53.93.93 0 0 1 1.122.543c.1.238.185.482.276.724l.755 2.018c.018.048.04.095.068.163.028-.05.05-.08.065-.115q.184-.402.364-.805.202-.451.696-.446c.368.002.735-.005 1.102.002a.693.693 0 0 1 .583 1.052.67.67 0 0 1-.578.337c-.18.006-.362.002-.543.002h-.158l-.202.444c-.167.372-.33.747-.503 1.116-.17.36-.461.549-.862.552a.91.91 0 0 1-.872-.584c-.077-.187-.143-.377-.214-.566l-.806-2.148c-.021-.057-.045-.113-.077-.191"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ActivityIcon20.js.map